<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<p class="ded"><em class="italic">For Oscar, perhaps you will be an engineer one day…</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?49f9f550